import React from 'react';
import { GalleryBlock } from 'components/gallery-block/GalleryBlock';
import { GalleryBlockItem } from 'components/gallery-block/GalleryBlockItem';
import { RichText } from 'components/rich-text/RichText';

export const GalleryBlockSlice = ({
  title,
  text,
  link,
  buttonText,
  buttonLabel,
  buttonCaption,
  buttonSubline,
  buttonNumber,
  items,
  index,
  isSlice,
}) => {
  return (
    <GalleryBlock
      index={index}
      title={title}
      text={RichText.render(text)}
      link={link}
      label={buttonLabel}
      buttonText={buttonText}
      buttonCaption={buttonCaption}
      buttonSubline={buttonSubline}
      buttonNumber={buttonNumber}
      isSlice={isSlice}
    >
      {items?.map((item, index) => (
        <GalleryBlockItem key={index} image={item.image} />
      ))}
    </GalleryBlock>
  );
};

export default GalleryBlockSlice;
